import { authenticatedRequest } from './apiClient';
import { ApiProfile, ApiProfileUpdate } from '../types/api';

export async function getProfile(): Promise<ApiProfile> {
  return authenticatedRequest<ApiProfile>('/profiles/me');
}

export async function updateProfile(
  updates: ApiProfileUpdate
): Promise<ApiProfile> {
  return authenticatedRequest<ApiProfile>('/profiles/me', {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}
